import React, { useEffect } from "react";
import { useEditor, SET_EDIT_FIELD } from "../../context/editor";
import { useTranslation } from "react-i18next";
function EditButton({ handleEditar, currentElement, closeEditField, action }) {
  const [editorState, editorDispatch] = useEditor();
  const { t } = useTranslation(["newEditor", "common"]);
  const handleClick = () => {
    handleEditar();
    editorDispatch({
      type: SET_EDIT_FIELD,
      data: true,
    });
  };
  useEffect(() => {
    if (editorState?.editorField === false) {
      closeEditField();
    }
  }, [editorState?.editorField]);

  return (
    <React.Fragment>
      {editorState?.currentElement?._id === currentElement &&
      editorState?.currentElement?.type !== "signature" &&
      editorState?.currentElement?.type !== "header" &&
      action === "clic" ? (
        <div
          className="EditButtonParent"
          style={{
            position: "relative",
            paddingBottom: "0px !important",
            userSelect: "none",
            // width: "600px",
            // height: "100px",
          }}
          // onDoubleClick={handleClick}
          contentEditable={false}
        >
          {" "}
          <button
            className={"EditButton font-weight-bold"}
            onClick={handleClick}
            contentEditable={false}
            style={{ userSelect: "none" }}
          >
            {t("editorButtons.edit")}
          </button>
        </div>
      ) : editorState?.currentElement?._id === currentElement &&
        editorState?.currentElement?.type !== "signature" &&
        editorState?.currentElement?.type !== "header" &&
        action === "doubleClic" ? (
        <div
          id="doubleClicHandler"
          contentEditable={false}
          style={{
            position: "absolute",
            top: "0px",
            left: "0px",
            width: "100%",
            height: "100%",
            cursor: "pointer",
            zIndex: 10000,
            userSelect: "none",
          }}
          onClick={handleClick}
        ></div>
      ) : (
        <span contentEditable={false} style={{ userSelect: "none" }}></span>
      )}
    </React.Fragment>
  );
}

export default EditButton;
